export default {
    MP: 'Menor Preço',
    MD: 'Maior Desconto',
    TP: 'Técnica e Preço',
    MTC: 'Melhor Técnica',
    CA: 'Conteúdo Artístico',
    ML: 'Maior Lance',
}